import { render, staticRenderFns } from "./CentralInventoryList.vue?vue&type=template&id=4ed346f7&scoped=true"
import script from "./CentralInventoryList.vue?vue&type=script&lang=js"
export * from "./CentralInventoryList.vue?vue&type=script&lang=js"
import style0 from "./CentralInventoryList.vue?vue&type=style&index=0&id=4ed346f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed346f7",
  null
  
)

export default component.exports